import { interact, cr } from "fire-wind-water";
import authService from "@/services/authService";
import { common } from "@/model/common";
import BaseComponent from "@/components/BaseComponent";
import md5 from "js-md5";
import { registerModel } from "@/model/register-model";
import configMixin from "@/mixin/config";
import Header from "@/components/Header";
import Banner from "@/components/Banner";

export default {
  name: "increase",
  components: {
    Header,
    Banner,
    BaseComponent,
  },
  mixins: [configMixin],
  data() {
    return {
      weChatId: common.weChatId,
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      backUrl: common.backUrl,
      configId: common.configId,
      formInfo: null,
      token: common.token,
      tokenInfo: "",
      verify: common.verify,
      formList: [],
      isSubmitting: false,
      inWeChat: interact.isWeChat,
      sess: "",
      isLoad: false,
    };
  },
  methods: {
    routerLogin() {
      common.routerPush(this, "login");
    },
    loadForm() {
      let self = this;
      let session = common.getSession();
      self.sess = session ? session.session : "123534234234";
      authService
        .getForm({
          tenantId: self.staticInfo?.tenantId || common.tenantId, // 增加静态化请求所需要的 tenantId 参数
          sess: self.sess,
          memberFormId: self.memberFormId,
          isNotAdd: 1,
        })
        .then((data) => {
          self.formInfo = data.content;
          common.handPage(self.formInfo);
          window.$sk.template.update({
            type: "link",
            data: {
              identity: 1,
              weChatId: self.formInfo.authWeChatId || 0,
              skObjectType: "member",
              skObjectId: self.memberFormId,
              meetingInstanceId: "",
              meetingType: "",
              skIsNotLink: "",
              memberFormId: "",
            },
          });
        });
    },
    afterLoadForm() {
      let self = this;
      let fields = [];
      cr.each(self.formInfo.items, (field) => {
        if (field.required == 1 && field.fieldName != "password") {
          if (!self.formInfo.values[field.fieldName]) {
            fields.push(field);
          } else if (
            (field.displayType == 7 || field.displayType == 8) &&
            !self.formInfo.values[field.fieldName]["mapId"]
          ) {
            fields.push(field);
          } else if (field.fieldType == "POLICY") {
            if (!self.formInfo.values[field.fieldName]) {
              fields.push(field);
            } else {
              if (
                self.formInfo.values[field.fieldName] !== field.privacyPolicyUrl
              ) {
                fields.push(field);
              }
            }
          }
        }
      });
      if (fields.length > 0) {
        self.formInfo.items = fields;
      } else {
        self.formInfo.items = [];
      }
      self.formList = self.formInfo.items;
      registerModel.getParamTree(self);
    },
    update() {
      let self = this;
      let answers = [];
      self.isSubmitting = true;
      let submitData = {
        memberFormId: self.memberFormId,
        sess: self.sess,
      };
      cr.each(self.formList, (item) => {
        let answer = {
          fieldName: item.fieldName,
          value: item.value.value,
        };
        if (item.fieldName === "password") {
          answer.value = md5(answer.value).toUpperCase();
        }
        answers.push(answer);
        if (item.fieldName == "mobile" && item.isSendSms == "1") {
          self.phone = item.value.value;
          submitData["verificationCode"] = item.value.checkCode;
        }
      });
      submitData["formData"] = answers;
      authService.update(submitData).then((data) => {
        self.afterRegisterHandler(data);
      });
    },
    beforeRegisterHandler() {
      registerModel.beforeRegisterHandler(this);
    },
    afterRegisterHandler() {
      let settingBackUrl;
      if (!this.backUrl) {
        let backUrlSetting = this.extras.backlink.href;
        settingBackUrl = RegExp("^https?:\\/\\/.+").test(backUrlSetting)
          ? backUrlSetting
          : "";
      }
      if (this.backUrl || settingBackUrl) {
        if (this.backUrl) {
          return common.handBackUrl(common.backUrl);
        } else {
          return window.$sk.goto(settingBackUrl);
        }
      } else {
        common.routerPush(this, "loginSuccess");
      }

      // if(this.backUrl) this.backUrl = "模板配置的backUrl" +window.location.search;
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      this.loadForm();
    },
    skLinkEnd() {
      this.verify = common.getVerify(this.weChatId);
      let self = this;
      authService
        .lookUp({
          sess: self.sess,
          tenantId: self.staticInfo?.tenantId || common.tenantId,
          moduleId: 0,
          instanceId: 0,
          cookieId: common.globalUserId,
          openId: 0,
        })
        .then(
          (res) => {
            if (res.result === 0) {
              let values = {};
              let content = res.content || [];
              cr.each(content, (item) => {
                values[item.key] = item.value;
              });
              self.formInfo.values = values;
              self.afterLoadForm();
              window.$sk.loading.hide();
            }
          },
          (res) => {
            window.$sk.tips.show(res["desc"]);
          }
        );
    },
  },
  created() {
    window.$sk.loading.show();
    this.sk = window.$sk.template.module(this);
  },
  mounted() {
    // this.loadForm();
  },
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
